import {Component} from '@angular/core';
import {ListViewItem} from '@domain/common/list-view/list-view-item';
import {Balise} from '@domain/admin/bibliotheque/notification/balise';
import {TranslateService} from '@ngx-translate/core';

/**
 * Item de la liste des balises
 */
@Component({
    selector: 'balises-list-item',
    templateUrl: './balises-list-item.component.html'
})
export class BalisesListItemComponent extends ListViewItem<Balise> {

    /**
     * Constructeur
     *
     * @param translateService Service de traduction
     */
    constructor(
        private translateService: TranslateService
    ) {super();}

    /**
     * Libellé du module pour l'affichage
     */
    getLibelleModule(): string {
        // Si la portée est vide, c'est une balise commune
        if (this.data?.idPortee === '') {
            return this.translateService.instant('admin.bibliotheque.notifications.message.detail.balise.communes');
        }

        // Récupération du libellé de la portée
        const idPortee = String(this.data?.idPortee ?? '');
        const clef = `portee.${idPortee}`;
        const libelle = this.translateService.instant(clef);
        return libelle !== clef ? libelle : idPortee;
    }

    /**
     * Libellé du type pour l'affichage
     */
    getLibelleType(): string {
        // Si la requête SQL est renseigné, c'est une balise personnalisée
        if (this.data?.requeteSQL) {
            return this.translateService.instant('admin.bibliotheque.notifications.message.detail.balise.personnalisee');
        }

        // Sinon, c'est une balise standard
        return this.translateService.instant('admin.bibliotheque.notifications.message.detail.balise.standard');
    }
}